const _ = require('lodash')
import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic'
import objectFitVideos from 'object-fit-videos';

export default {
  init() {
    objectFitVideos(document.querySelectorAll('.promotional-banner__bg--video'))
    this.handlePagination()
    this.handleMenuScroll()
    this.handleMegaMenu()
    this.handleCustomMenu()
    this.handleSearch()
    this.handleSearchAjax()
    this.mobileMenuHandler()
    this.videoOverlayHandler()
    this.videoPopupHandler()
    this.imagePopupHandler()
    // this.handleGatewaysNotification()
    this.handleHoverProductFamilies()
    this.buildAccordion()
    this.handleBlogMenu()
    this.handleSocial()
    this.handleLanguageSwitcher()
    this.handleMenuScrollWithPromoActive()
    this.handleDropdownReveal()
    this.setUTMQueryParamsCookie()

    $('.transition-on-load').removeClass('transition-on-load');

    // handle links with @href started with '#' only
    $(document).on('click', 'a[href^="#"]', function(e) {
        // target element id
        var id = $(this).attr('href');

        // target element
        var $id = $(id);
        if ($id.length === 0) {
            return;
        }

        var offset = ($id.data('offset')) ? $id.data('offset') : 80;

        // prevent standard hash navigation (avoid blinking in IE)
        e.preventDefault();

        // top position relative to the document
        var pos = $id.offset().top;

        // animated top scrolling
        $('body, html').animate({scrollTop: pos - offset}, 700);
    });

    // Open tab from URL hash
    if (window.location.hash && $('body').find('.nav.nav-tabs').length > 0) {
      $('body').find('.nav.nav-tabs .nav-item[data-hash="'+window.location.hash+'"]').trigger('click');
    }

    // Wrap noptification buttons
    $( '#cn-accept-cookie' ).wrap( '<div class="cta cta-purple"></div>' ).addClass('no-deco');
    $( '#cn-more-info' ).wrap( '<div class="cta cta-black-border ml-3"></div>' ).addClass('no-deco');

    /*
    // Hide product notifications banner
    $('#product-notification .close').on('click', function(){
      $.cookie('product_notification_accepted', 'true');
    });
    if ($.cookie('product_notification_accepted') != 'true') {
      $('#product-notification').css('display', 'block');
    }
     */
  },

  isInViewport(element, offset = 0) {
    var elementTop = element.offset().top + (offset/1.5);
    var elementBottom = elementTop + element.outerHeight() - offset;

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  },

  handleDropdownReveal() {
    $('.cta-dropdown').click(function (e) {
      e.preventDefault();
      const target = $(this).attr('data-target')
      $(this).toggleClass('active')
      if($(this).hasClass('active')) {
        $(target).slideDown()
      } else {
        $(target).slideUp()
      }
    })
  },

  handlePagination() {
    const that = this;
    $('.nav-links a').click(function (e) {
      e.preventDefault();
      let container = $(this).parents('.tab-pane');
      let el = $(this).html();
      let action = $(container).find('input[name="action"]').val();
      let searchTerm = $(container).find('input[name="s"]').val();
      let ajaxUrl = $('body').attr('data-ajax-url');
      let start_time = new Date().getTime();
      let data = {
        action: action,
        el: el,
        s: searchTerm,
      };
      $.ajax({
        type: 'POST',
        url: ajaxUrl,
        data: data,
        success: function (data) {
          console.log(ajaxUrl, ' Request took ',  new Date().getTime() - start_time, 'ms')
          $(container).html(data);
          that.handlePagination();

          if ($('body').find('.nav.nav-tabs').length > 0) {
            var pos = $('body').find('.nav.nav-tabs').offset().top;
            var offset = 80;
            $('body, html').animate({scrollTop: pos - offset}, 700);
          }
        },
      });
    });
  },
  videoOverlayHandler() {
    $('#video-popup').on('hidden.bs.modal', function () {
      $(this).find('iframe').attr('src', '');
    })
    $('#video-popup').on('shown.bs.modal', function () {
      $(this).find('iframe').attr('src', $(this).find('iframe').data('url'));
    })
  },
  videoPopupHandler() {
    $('.modal--video-popup').each(function () {
      $(this).on('hidden.bs.modal', function () {
        $(this).find('iframe').attr('src', '');
      });

      $(this).on('show.bs.modal', function () {
        $(this).appendTo('body');
        $(this).find('iframe').attr('src', 'https://www.youtube-nocookie.com/embed/' + $(this).data('video-id') + '?rel=0&amp;autoplay=1&amp;modestbranding=1');
      });
    });
  },
  imageModal(image, title) {
    return `
      <div class="modal modal--image modal--image-popup fade" tabindex="-1" role="dialog" style="display: none;" aria-modal="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative text-dark pt-5 d-flex justify-content-center">
                <button type="button" class="close mr-2 mt-2" data-dismiss="modal" aria-label="Close">
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="4" y="0.9375" width="1.32583" height="19.8874" transform="rotate(-45 4 0.9375)" fill="white"></rect><rect width="1.32583" height="19.8874" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 19 0.9375)" fill="white"></rect>  <defs> <filter id="filter0_d" x="0" y="0" width="23" height="23" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"> <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix><feOffset dy="4"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend> <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend></filter></defs></svg>
                </button>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                          <img class="modal-image" src="${image}" alt="${title}" title="${title}">
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    `;
  },
  imagePopupHandler() {
    const that = this;

    $('.action-image-popup').on('click', function (e) {
      e.preventDefault();
      const image = $(this).data('image');
      const title = $(this).data('title');
      const modal = $(that.imageModal(image, title));

      modal.modal('show');
      modal.on('hidden.bs.modal', function () {
        $('.modal--image-popup').remove();
      });
    });
  },
  mobileMenuHandler() {
    const that = this;
    $('.navbar').on('show.bs.collapse', function () {
      that.moveToTheTopIfPromoActive();
      $('body').addClass('mobile-menu-open');
    })
    $('.navbar').on('hide.bs.collapse', function () {
      $('body').removeClass('mobile-menu-open');
    })
    $('#menu-main-navigation-mobile li.menu-item-has-children').click(function (e) {
      e.stopPropagation();
      $(this).find('>.sub-menu').slideToggle();
      $(this).toggleClass('open');
      if ($(this).parent('#menu-main-navigation-mobile').length) {
        $('#menu-main-navigation-mobile').toggleClass('open')
      }
    })
    $('#menu-main-navigation-mobile li.menu-item-has-children > a:first-child').click(function (e) {
      e.preventDefault();
    })
  },
  handleSearchAjax() {
    const form = $('#search-form')
    const that = this;

    $(form).submit(function (e) {
      e.preventDefault();
      that.performAjaxSearch(form)
    });

    $(form).find('input').on('keyup', _.debounce(function () {
      that.performAjaxSearch(form)
    }, 1000));
  },
  performAjaxSearch(form) {
    $.ajax({
      url: $(form).attr('action'),
      method: 'POST',
      data: $(form).serialize(),
    })
      .done(function( html ) {
        $('#results-holder').html( html );
      });
  },
  handleMenuScroll() {
    const controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({ triggerElement: 'body', offset: 100, reverse: true, triggerHook: 0 })  
      .setClassToggle('body', 'scrolled') // add class toggle
      .addTo(controller);
  },
  handleMenuScrollWithPromoActive() {
    if ($('body.promo-active').length > 0){
      const controller = new ScrollMagic.Controller();
      new ScrollMagic.Scene({triggerElement: 'body.promo-active > div.wrap', offset: 0, reverse: true, triggerHook: 0})
        .setClassToggle('body', 'navbar-in-top') // add class toggle
        .addTo(controller);
    }
  },
  handleSearch() {
    $('.search-overlay .close, .banner .search-span').click(function (e) {
      e.preventDefault();
      $('body').toggleClass('search-open no-scoll')
    })
  },
  moveToTheTopIfPromoActive() {
    if ($('body').hasClass('promo-active') && !$('body').hasClass('navbar-in-top')) {
      window.scrollTo({
        top: $('body > div.wrap').offset().top + 5,
        left: 0,
        behavior: 'smooth',
      })
    }
  },
  handleMegaMenu() {
    const that = this;
    const hiddenMenuProductPre = $('#menu-main-navigation-hidden .move-me-product-pre');
    const hiddenMenuProductPost = $('#menu-main-navigation-hidden .move-me-product-post');
    const hiddenMenuSolutionPost = $('#menu-main-navigation-hidden .move-me-solution-post');
    const itemLang = $('#menu-main-navigation > li.wpml-ls-item');
    $(itemLang).addClass('globe');

    $('#menu-main-navigation > li.menu-item-has-children').click(function (e) {
      e.preventDefault();

      that.moveToTheTopIfPromoActive()

      const isProductMenu = $(this).is(':first-of-type');
      const isSolutionMenu = $(this).is(':nth-of-type(2)');
      const origin = $(this);
      const itemClass = $(origin).attr('class').match(/menu-item-\d+|wpml-ls-slot-\d+/)[0];

      if ($(origin).hasClass('mega-menu-open')) {
        $('#menu-main-navigation-hidden > li').hide();
        $('body, #menu-main-navigation > li').removeClass('mega-menu-open');
      } else {
        $('#menu-main-navigation-hidden > li').hide();
        $('#menu-main-navigation-hidden > li.' + itemClass).show();
        $('body, #menu-main-navigation > li').removeClass('mega-menu-open');
        $('body').addClass('mega-menu-open');
        $(origin).addClass('mega-menu-open');
      }

      /* HACK: TODO: seperate all the header menus out to prevent having to fudge */
      const non_portfolio_menu_post = $('#non-portfolio-menu-post');
      let portfolioMenuPost;
      if (isProductMenu){
        const portfolioMenuPre = hiddenMenuProductPre;
        $('#menu-main-navigation-hidden > li:first-child > a:first-child').after(portfolioMenuPre);
         portfolioMenuPost = hiddenMenuProductPost;
      } else if (isSolutionMenu){
        portfolioMenuPost = hiddenMenuSolutionPost;

      } else {
        portfolioMenuPost = '';
        
      }
      non_portfolio_menu_post.html(portfolioMenuPost);
    });

    // Handle sub-menu item expand collapse
    $('#menu-main-navigation-hidden li.menu-item-has-children li.menu-item-has-children li.menu-item-has-children > a').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('collapsed');
      $(this).parent().find('>.sub-menu').slideToggle();
    });
  },
  handleCustomMenu() {
    if ($('#menu-custom-navigation > li.wpml-ls-item').length) {
      $('#menu-custom-navigation > li.wpml-ls-item').addClass('globe');
    }
  },
  handleGatewaysNotification() {
    $('#product-notification .close').click(function (e) {
      e.preventDefault();
      $('#product-notification').addClass('d-none');
    })
  },
  handleHoverProductFamilies() {
    $('.tax-products .product-list:not(.no-anim), .template-solutions .product-list:not(.no-anim), .template-data-guide-gateway .product-list:not(.no-anim), .template-data-guide-gateway .product-list:not(.no-anim), .tax-portfolio .product-list:not(.no-anim), .tax-industry .product-list:not(.no-anim)')
    .on('mouseover', function(){
      $(this).find('.centered').addClass('hover')
      $(this).find('.short-description').addClass('no-height');
      $(this).find('.sub-product-list').removeClass('no-height');
    })
    .on('mouseleave', function(){
      $(this).find('.centered').removeClass('hover')
      $(this).find('.short-description').removeClass('no-height');
      $(this).find('.sub-product-list').addClass('no-height');
    });
  },
  buildAccordion() {
    var acc = document.getElementsByClassName('accordion-items');
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function() {
        this.classList.toggle('active');
        var panel = this.nextElementSibling;
        if (panel.style.display === 'block') {
          panel.style.display = 'none';
        } else {
          panel.style.display = 'block';
        }
      });
    }
  },

  handleBlogMenu() {
    $('.blog-categories-filter ul li').addClass('col-lg-3 col-md-6 col-sm-12');
    $('.open-categories').on('click', function(e) {
         e.preventDefault();
         $('.blog-categories-filter').fadeToggle(100)
         $(this).toggleClass('blog-categories-open');
    });
  },

  handleSocial() {
    $('.share-social-link').click(function(e) {
      e.preventDefault();
          const width = 720;
          const height = 600;
          const toppx = ($(window).height() / 2) - (height / 2);
          const leftpx = ($(window).width() / 2) - (width / 2);
      window.open($(this).attr('href'), 'Social sharing', 'width=' + width + ',height=' + height + ',scrollbars=no,left=' + leftpx + 'top='+toppx);
    });

  },
  handleLanguageSwitcher() {
    $('.wpml-ls-menu-item.wpml-ls-current-language > a:first-child').click(function(e) {
      e.stopPropagation();
      e.preventDefault();
      $(this).parent().toggleClass('open');
      $(this).parent().find('.sub-menu').slideToggle();
      if ($(this).parents('#menu-main-navigation-mobile').length) {
        $('#menu-main-navigation-mobile').toggleClass('open')
      }
    })
  },
  setUTMQueryParamsCookie() {
    if (!window.location.search) {
      return;
    }

    const queryParams = this.getQueryParams(window.location.search); 
    const allowedParams = ['utm_campaign', 'utm_source', 'utm_content', 'utm_medium', 'utm_term'];
    const cookie = _.chain(queryParams)
      .map(function(param) {
        if (_.includes(allowedParams, param.name)) {
          return param.name + '=' + param.value;
        }
      })
      .join('&')
      .value();

    $.cookie('UTM', cookie.replace(/&+$/, ''), { path: '/' });

  },
  getQueryParams(query) {
    return _.chain(query)
      .replace('?', '')
      .split('&')
      .map(function(e) {
        const item = _.split(e, '=', 2);
        return { name: item[0], value: item[1] }
      })
      .value();
  },
  setUTMQueryParamsToAnchors() {
    const params = $.cookie('UTM');

    if(!params) {
      return;
    }

    $('a').each(function() {
      const anchor = this;
      const hash = anchor.hash ? anchor.hash : anchor.href.substr(-1) === '#' ? '#' : '';

      if (anchor.href == 'javascript:void(0)' || hash === '#' || anchor.hostname !== window.location.hostname) {
        return;
      }

      if (anchor.search && window.location.search !== anchor.search) {
        anchor.href = anchor.origin + anchor.pathname + anchor.search + '&' + params + hash;
        return;
      }

      anchor.href = anchor.origin + anchor.pathname + '?' + params + hash;
    });
  },
  setUTMQueryParamsToForms() {
    const params = $.cookie('UTM');
    const form = $('.contact-form');

    if(!params) {
      return;
    }

    if (form.length > 0 && form.attr('data-redirect')) {
      const updatedRedirectURL = form.attr('data-redirect') + '&' + params;
      form.attr('data-redirect', updatedRedirectURL);
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    this.setUTMQueryParamsToAnchors();
    this.setUTMQueryParamsToForms();
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js